import { CheckCircle } from "lucide-react";
import { toast } from "sonner";

interface SuccessToastProps {
  message: string | React.ReactNode;
}

export const SuccessToast = ({ message }: SuccessToastProps) => {
  toast.custom(() => (
    <div className="flex items-center gap-3 p-4 bg-[#F0FFF4] text-[#1F6B45] font-montserrat text-xs font-medium rounded shadow-md">
      <CheckCircle className="text-[#1F6B45]" />
      <div>
        {typeof message === "string" ? (
          <p className="font-semibold">{message}</p>
        ) : (
          message
        )}
      </div>
    </div>
  ));
};
